import { securedApiRequest } from "./SecuredApi";

/**
 * Fetch all notifications for the current user.
 * @param {string} email
 * @returns {Promise<{notifications: Array}>}
 */
export const fetchNotifications = async (email) => {
    const encoded = encodeURIComponent(email);
    return securedApiRequest(
        `/notifications/?email=${encoded}`,
        "GET",
        null,
        true
    );
};

/**
 * Mark a single notification as read, then return the updated notification.
 * @param {string|number} notificationId
 * @param {string} email
 * @returns {Promise<object>}
 */
export const markNotificationAsRead = async (notificationId, email) => {
    const encoded = encodeURIComponent(email);
    return securedApiRequest(
        `/notifications/mark-as-read/${notificationId}/?email=${encoded}`,
        "POST",
        null,
        true
    );
};

